import React, { useState, useEffect } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import {
  resetLinkedList,
  getLabelAndValue,
  resetList,
} from "../../CommonFuntion/SchemaValidation";
import { titleCase } from "../../CommonFuntion/SchemaValidation";

const CssSelectField = styled(Select)({
  ".MuiSelect-select": {},
  "& label.Mui-focused": {
    color: "#ec0000c4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#ec0000c4",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ec0000c4",
    },
    "&:hover fieldset": {
      borderColor: "#ec0000c4",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ec0000c4",
    },
  },
  "& div.MuiSelect-nativeInput": {
    fontSize: 12,
  },
});

export function LLIDropDown(props) {
  const {
    name,
    label,
    options,
    value,
    tagName,
    prefix,
    validation,
    schemaPageId,
    schemaResult,
    schemaItem,
    childLists,
    setChildOpt,
    childPageId,
    childItemId,
    formData,
    mandatoryByLabelName,
    disableByLabelName,
    handleResetELCList,
    handleELLValue,
    childOpt,
    setLLIValue,
    LLIValue,
  } = props;
  const [options2, setOptions2] = useState(options);
  const { setFieldValue, values } = useFormikContext();
  useEffect(() => {
    if (formData[name] && formData[name] !== null && formData[name] !== "") {
      if (prefix === "LLI") {
        const optionValue = options.find(
          (x) => x.label === formData[name]
        )?.value;
        const optionsData = Object.entries(childLists)?.find(
          ([key]) => key === optionValue
        )[1];
        const res = {
          childPageId,
          childItemId,
          optionsData,
        };
        setChildOpt(res);

        //setLLIValue(optionValue);
      }
    }
  }, [formData, LLIValue]);

  const id = `${tagName}-input`;
  const handleChange = (e, selected) => {
    const { value } = e.target;

    let parentItem = schemaResult?.find((x) => x.schemaItem === schemaItem);
    let childItem = schemaResult?.find(
      (x) => x.schemaItem === parentItem.childItemId
    );
    if (childItem) setFieldValue(childItem.fieldName, "");
    if (value) {
      const optionValue = options.find(
        (x) => x.label === e.target.value
      )?.value;
       setLLIValue(optionValue);
      let optionsData = Object.entries(childLists)?.find(
        ([key]) => key === optionValue
      )[1];
      let res = {
        childPageId,
        childItemId,
        optionsData,
      };
      setChildOpt(res);
      resetList(childPageId, childItemId, schemaResult, values);
      setFieldValue([name], value);
    } else {
      let optionsData = [];
      let res = {
        childPageId,
        childItemId,
        optionsData,
      };
      setLLIValue("");

      setChildOpt(res);
      resetList(childPageId, childItemId, schemaResult, values);
      setFieldValue([name], value);
    }
  };

  // Safely get the selected label value from Formik values
  const selectedValueArray = getLabelAndValue(values[name] || "");
  const selectedValue = Array.isArray(selectedValueArray)
    ? selectedValueArray[0]
    : "";
  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label className="font-css" id={id}>
              {titleCase(label.replace("_", " "))}

              {(validation?.mandatory ||
                (validation?.mandatoryByLabelName &&
                  validation?.mandatoryByLabelName ===
                    mandatoryByLabelName)) && (
                <span className="mandatory-validation">{"*"}</span>
              )}
            </label>
          )}
        </div>

        <div className="control-bottom-border">
          <FormControl variant="standard" aria-labelledby={id}>
            <CssSelectField
              labelId={label}
              id={tagName}
              name={name}
              key={name}
              tagname={tagName}
              fieldname={name}
              prefix={prefix}
              className="control-width-font"
              style={{
                fontSize: "12px",
              }}
              onChange={handleChange}
              label={titleCase(label.split(" ")[0].replace("_", " "))}
              value={selectedValue}
              disabled={
                validation?.disableByLabelName &&
                validation?.disableByLabelName === disableByLabelName
              }
            >
              <MenuItem
                style={{
                  fontSize: "12px",
                }}
                value=""
              ></MenuItem>
              {options2.map((optn, index) => (
                <MenuItem
                  style={{
                    fontSize: "12px",
                  }}
                  key={index}
                  value={optn.label}
                  label={optn.label || optn.value}
                >
                  {optn.label}
                </MenuItem>
              ))}
            </CssSelectField>
          </FormControl>
          <ErrorMessage
            name={name}
            render={(msg) => <div className="is-invalid">{msg}</div>}
          />
        </div>
      </div>
    </>
  );
}
